<app-card title="Historial de Flows">
  <!-- Filtros -->
  <div class="row mb-15">
    <div class="col-lg-3 col-md-6 col-sm-6">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Flow</mat-label>
        <mat-select [(ngModel)]="selectedFlowToken">
          <mat-option value="">Todos</mat-option>
          <mat-option *ngFor="let flow of flowOptions" [value]="flow.token">
            {{ flow.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-6">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Estado</mat-label>
        <mat-select [(ngModel)]="selectedEventType">
          <mat-option *ngFor="let opt of eventTypeOptions" [value]="opt.value">
            {{ opt.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-6">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Desde</mat-label>
        <input matInput [matDatepicker]="pickerFrom" [(ngModel)]="dateFrom" />
        <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-6">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Hasta</mat-label>
        <input matInput [matDatepicker]="pickerTo" [(ngModel)]="dateTo" />
        <mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <div class="row mb-15">
    <div class="col-12 text-right" style="text-align: right">
      <button mat-button class="default-btn bg-main-color-blue" (click)="applyFilters()">
        <i class="ri-search-line"></i> Filtrar
      </button>
      <button mat-button class="default-btn" (click)="clearFilters()">
        <i class="ri-refresh-line"></i> Limpiar
      </button>
    </div>
  </div>

  <!-- Tabla -->
  <div class="recent-files-table table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th class="fw-semibold subtitle-card-color">Fecha</th>
          <th class="fw-semibold subtitle-card-color">Flow</th>
          <th class="fw-semibold subtitle-card-color">Estado</th>
          <th class="fw-semibold subtitle-card-color">Teléfono</th>
          <th class="fw-semibold subtitle-card-color">Programa</th>
          <th class="fw-semibold subtitle-card-color">Resultado</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let event of listEvents">
          <td class="subtitle-card-color">
            {{ event.createdAt | date: 'dd/MM/yyyy HH:mm' }}
          </td>
          <td class="subtitle-card-color">
            {{ flowLabel(flowTokenOf(event)) }}
          </td>
          <td class="subtitle-card-color">
            <span
              class="badge"
              [ngClass]="{
                'bg-main-color-blue': event.eventType === 'flow_started',
                'bg-success': isSucceeded(event),
                'bg-danger': isFailed(event)
              }"
            >
              {{ event.eventType === 'flow_started' ? 'Iniciado' : 'Completado' }}
            </span>
          </td>
          <td class="subtitle-card-color">{{ event.number || event.bsuid || '—' }}</td>
          <td class="subtitle-card-color">{{ event.programName || '—' }}</td>
          <td class="subtitle-card-color">{{ resultSummary(event) }}</td>
        </tr>
        <tr *ngIf="!loading && listEvents.length === 0">
          <td colspan="6" class="text-center subtitle-card-color">
            No se encontraron eventos de flows con los filtros seleccionados.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <mat-paginator
    [length]="totalItems"
    [pageIndex]="pageIndex - 1"
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 20, 50, 100]"
    showFirstLastButtons
    (page)="onPageChange($event)"
  ></mat-paginator>
</app-card>
